import { render, staticRenderFns } from "./GongziDemo.vue?vue&type=template&id=bb5f62dc&"
import script from "./GongziDemo.vue?vue&type=script&lang=js&"
export * from "./GongziDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports